export interface Message {
  role: string;
  content: string;
  buttons?: MessageButton[];
  is_template?: boolean;
}

export enum MessageButton {
  looks_good = "looks_good",
  make_edits = "make_edits",
  skip = "skip",
}
